export default {
      id: "sd-logo-usage",
      viewBox: "0 0 103 24",
      url: "/" + "assets/sprite.svg#sd-logo",
      toString: function () {
        return this.url;
      }
    }